import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges
} from '@angular/core';

@Component({
	selector: 'app-empty-table',
	templateUrl: './empty-table.component.html',
	styleUrls: ['./empty-table.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyTableComponent implements OnChanges {
	@Input() type:
		'users' |
		'profile' |
		'roles' |
		'rules' |
		'clients' |
		'currencies' |
		'rates' |
		'sources' = 'profile';
	@Input() showImg = true;
	@Input() disabled = false;

	@Output() readonly newUser = new EventEmitter();
	@Output() readonly newRole = new EventEmitter();
	@Output() readonly newRule = new EventEmitter();
	@Output() readonly newClient = new EventEmitter();
	@Output() readonly newSource = new EventEmitter();
	@Output() readonly newCurrency = new EventEmitter();
	@Output() readonly newRate = new EventEmitter();

	title = '';
	subTitle = '';
	buttonText = '';
	optionalButtonText = '';
	icon = '';

	constructor() {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if ( changes['type'] ) {
			switch (this.type) {
				case 'users':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'users_roles.users.create';
					this.icon = 'icon-plus';
					break;
				case 'roles':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'users_roles.roles.create';
					this.icon = 'icon-plus';
					break;
				case 'profile':
					this.title = '';
					this.subTitle = '';
					this.buttonText = '';
					this.icon = '';
					break;
				case 'rules':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'rules.add';
					this.icon = 'icon-plus';
					break;
				case 'clients':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'clients.add';
					this.icon = 'icon-plus';
					break;
				case 'sources':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'sources.add';
					this.icon = 'icon-plus';
					break;
				case 'currencies':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'currencies.add';
					this.icon = 'icon-plus';
					break;
				case 'rates':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'rates.add';
					this.icon = 'icon-plus';
					break;
				default:
					break;
			}
		}
	}

	clicked(): void {
		switch (this.type) {
			case 'users':
				this.newUser.emit(undefined);
				break;
			case 'roles':
				this.newRole.emit(undefined);
				break;
			case 'rules':
				this.newRule.emit(undefined);
				break;
			case 'clients':
				this.newClient.emit(undefined);
				break;
			case 'sources':
				this.newSource.emit(undefined);
				break;
			case 'currencies':
				this.newCurrency.emit(undefined);
				break;
			case 'rates':
				this.newRate.emit(undefined);
				break;
			default:
				break;
		}
	}

	optionalButtonClicked(): void {
		switch (this.type) {
			default:
				break;
		}
	}
}
